<template>
    <button @click="endConference(true)" class="room__control room__call-off r-button" type="button">
        <span class="room__control-text">Завершить звонок</span>
    </button>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        name: "End",
        methods:{
            ...mapActions('conference', [
                'endConference'
            ])
        }
    }
</script>
